import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";
import * as Submodal from "./submodals";

interface PropsInterface {
  location: any;
  Store: any;
  Dispatch: any;
}

interface StateInterface {
  step: number;
}

class Default extends React.Component<PropsInterface, StateInterface> {
  public constructor(props: PropsInterface) {
    super(props);
    this.state = {
      step: 1,
    };
    this.switchSteps = this.switchSteps.bind(this);
  }

  private switchSteps() {
    switch (this.state.step) {
      case 1:
        return (
          <Submodal.Step1
            back={() => {
              // console.log("TEST");
              // this.setState({ step: 3 });
            }}
            next={() => {
              this.setState({ step: 2 });
            }}
          />
        );
      case 2:
        return (
          <Submodal.Step2
            back={() => {
              this.setState({ step: 1 });
            }}
            next={() => {
              this.setState({ step: 3 });
            }}
          />
        );
      case 3:
        return (
          <Submodal.Step3
            backStep={() => {
              this.setState({ step: 2 });
            }}
            next={() => {
              this.setState({ step: 4 });
            }}
          />
        );
      case 4:
        return (
          <Submodal.Step4
            back={() => {
              this.setState({ step: 3 });
            }}
            next={() => {
              // this.setState({ step: 1 });
              this.props.Dispatch(Middleware.Ui.Modal.close());
            }}
          />
        );
    }
  }
  public render() {
    return (
      <>
        <div className="modal-background">
          <div className="modal">
            <h2>Предложить встречу | </h2>
            <br />
            {this.switchSteps()}
            {/* <button
              onClick={() => {
                this.props.Dispatch(Middleware.Ui.Modal.open("Default"));
              }}
            >
              Далее
            </button> */}
            {/* <button
              onClick={() => {
                this.props.Dispatch(Middleware.Ui.Modal.close());
              }}
            >
              Close modal
            </button>
            <button
              onClick={() => {
                this.props.Dispatch(Middleware.Ui.Modal.closeAll());
              }}
            >
              Close all modals
            </button> */}
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: any) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(Default)
);
